import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Button } from "@oc-labs/wt-storybook";

export default function ModalConfirmDelete({
    isOpen,
    closeModal,
    onConfirm,
    title = "Confirm Deletion",
    description = "Are you sure you want to delete this item? This action cannot be undone." }) {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal}>
                <div className="fixed inset-0 backdrop-brightness-75" />

                <div className="fixed inset-0 flex items-center justify-center">
                    <Dialog.Panel className="w-full max-w-sm bg-white rounded-2xl shadow-lg p-4">
                        <Dialog.Title className="text-xl font-semibold text-center">
                            {title}
                        </Dialog.Title>

                        <Dialog.Description className="mt-2 text-center text-gray-600">
                            {description}
                        </Dialog.Description>

                        <div className="h-[1px] bg-gray-300 my-4" />

                        <div className="mt-4 flex gap-2">
                            <Button
                                type="tertiary"
                                onClick={closeModal}
                                className="w-1/2"
                            >
                                Cancel
                            </Button>

                            <Button
                                type="primary"
                                onClick={onConfirm}
                            >
                                Delete
                            </Button>
                        </div>
                    </Dialog.Panel>
                </div>
            </Dialog>
        </Transition>
    );
}
